export default {
  UNSPECIFIED: 'unspecified',
  NO: 'false',
  YES: 'true',
}
